import React, { Component } from "react";
import { connect } from "react-redux";
import { Input } from "antd";
import CustomCheckbox from "./custom-checkbox/CustomCheckbox";
import { ACTION_TYPES } from "reducers/actionTypes";
import "assets/stylesheets/EnterSubjectMarks.scss";
import { parsePositiveInteger } from "utils/generalHelpers";

class EnterSubjectMarks extends Component {
  handleHscMarkChange = (e, sub) => {
    const subjectKey = sub.subject_id;
    const { value } = e.target;
    const sanitizedValue = parsePositiveInteger(value);
    const newMark = {};
    newMark[subjectKey] = sanitizedValue;
    this.props.dispatch({
      type: ACTION_TYPES.subjects.update,
      data: { hscMarks: Object.assign({}, this.props.hscMarks, newMark) },
    });
  };

  render() {
    const { knowAtar, hscMarks } = this.props;
    return (
      <div>
        <div className="subject-marks">
          {this.props.selectedSubjects.map((sub, i) => (
            <div className="subject-mark" key={i}>
              <div className="subject-mark-label">
                <CustomCheckbox
                  id={`selected-${sub.subject_id + sub.subject_desc}`}
                  key={sub.subject_id + sub.subject_desc}
                  label={sub.subject_desc}
                  selected={this.props.subjectSelected(sub)}
                  disabled={false}
                  onClickCheckbox={() => this.props.handleSubjectChange(sub)}
                ></CustomCheckbox>
              </div>
              {knowAtar && (
                <Input
                  size="large"
                  aria-label={`Enter your HSC mark for the subject ${sub.subject_desc}`}
                  className="subject-mark-input"
                  placeholder="Enter your HSC mark"
                  onChange={(event) => this.handleHscMarkChange(event, sub)}
                  value={hscMarks[sub.subject_id]}
                />
              )}
            </div>
          ))}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (store) => {
  const { activeState, knowAtar } = store.selectStateReducer;
  const { selectedSubjects, hscMarks } = store.selectSubjectsReducer;
  return {
    activeState,
    selectedSubjects,
    knowAtar,
    hscMarks,
  };
};

export default connect(mapStateToProps)(EnterSubjectMarks);
